import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Skeleton, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { MissionEnumsLists } from "../../../common/constants";
import config from "../../../config";
import axios from "axios";
import { formatText } from "../../../common/helpers";
import { useDevice } from "../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    tableRoot: {
      width: "auto",
      height: "auto",
      background: theme.palette.background.grey,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(2)
    },
    table: {
      width: "100%",
      "& td": {
        border: "none",
        padding: theme.spacing(1),
        paddingLeft: 0,
        paddingBottom: theme.spacing(0.5),
        paddingTop: theme.spacing(0.5),
      },
    },
    isMobilePortraitView: {
      "& .MuiDialogContent-root": {
        padding: theme.spacing(1.5),
      },
      "& h2.MuiTypography-root.MuiDialogTitle-root": {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5)
      },
      "& .MuiDialogActions-root": {
        padding: theme.spacing(1.5),
        paddingBottom: theme.spacing(0),
        flexDirection: "column-reverse",
        "& > button": {
          width: "100%",
          margin: 0,
          marginBottom: theme.spacing(1),
          padding: theme.spacing(1),
          flex: 1,
        }
      }
    }
  })
);

export default function RegistrationDialog(props) {
  const { task, registration } = props;
  const { isMobilePortraitView } = useDevice();
  const { t } = useTranslation();
  const { classes } = useStyles();
  const [regData, setRegData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!registration) return;

    axios(`${config.apiUrl}/api/mission/vehicleregistration/public?registration=${registration}`)
      .then(res => {
        setRegData(res.data);
      })
      .catch(err => {
        setError(true);
        console.log(err);
      });
  }, [registration]);

  return (
    <Dialog
      open
      onClose={() => task.throw()}
      maxWidth="xs"
      fullWidth
      className={` ${isMobilePortraitView ? classes.isMobilePortraitView : ""}`}
    >
      <DialogTitle id="alert-dialog-title">
        {error ? t("registrationDialog:errorTitle") : t("registrationDialog:title")}
      </DialogTitle>
      <DialogContent>

        {
          error ? (
            <Box>
              <Typography variant="body1">{t("registrationDialog:notFound")}</Typography>
            </Box>
          ) : (
            <Box className={classes.tableRoot}>
              <Table className={classes.table}>
                <TableBody>

                  <TableRow>
                    <TableCell>
                      <Typography variant="body2" color="textSecondary">{t("registrationDialog:registration")}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2"> {!!regData ? (regData.registration || "-") : <Skeleton width={120} height={20} />}</Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <Typography variant="body2" color="textSecondary">{t("registrationDialog:makeAndModel")}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">{!!regData ? (formatText(" ", regData.make, regData.model) || "-") : <Skeleton width={120} height={20} />}</Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <Typography variant="body2" color="textSecondary">{t("registrationDialog:color")}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">{!!regData ? (regData?.color || "-") : <Skeleton width={120} height={20} />}</Typography>
                    </TableCell>
                  </TableRow>


                  <TableRow>
                    <TableCell>
                      <Typography variant="body2" color="textSecondary">{t("registrationDialog:fuelType")}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">{!!regData ? t(`enums:fuelType:${MissionEnumsLists.FuelType[regData?.fuel || 0]}`) : <Skeleton width={120} height={20} />}</Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          )
        }

      </DialogContent>
      {
        error ? (
          <DialogActions>
            <Button onClick={() => task.throw("cancelled")} variant="contained">
              {t("registrationDialog:close")}
            </Button>
          </DialogActions>
        ) : (
          <DialogActions>
            <Button onClick={() => task.throw("cancelled")}>
              {t("registrationDialog:cancel")}
            </Button>
            <Button variant="contained" color={"primary"} onClick={() => task.complete(regData)} autoFocus disabled={!regData}>
              {t("registrationDialog:confirm")}
            </Button>
          </DialogActions>
        )
      }
    </Dialog >
  );
}